import type { ReactNode } from 'react';

import { useTranslationWithComponents } from '@modules/_shared/hooks/useTranslationWithComponents';

type ProfileInquiryAssignmentTitleProps = {
  contact?: ReactNode;
  agent: ReactNode;
  suffix?: ReactNode;
};

export const ProfileInquiryAssignmentTitle = ({
  contact,
  agent,
  suffix,
}: ProfileInquiryAssignmentTitleProps) => {
  const t = useTranslationWithComponents();

  return (
    <>
      {contact
        ? t('{{contact}} contacted {{agent}} through their agent profile.', {
            contact,
            agent,
          })
        : t('This person contacted {{agent}} through their agent profile.', {
            agent,
          })}
      {suffix}
    </>
  );
};
